import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'

type Data = {
  proposalId: string
  validation?: boolean
}

export const turnOrder = async (data: Data): Promise<any> => {
  return axios.post(`/orders/proposals/${data.proposalId}/send`, data)
}

export function useTurnOrder() {
  const queryClient = useQueryClient()
  return useMutation(turnOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      toast.success('Orçamento enviado para fila de processamento com sucesso!')
    },
    onError: (error: any) => {
      let errorMsg = 'Não foi possível enviar para o processamento!'

      if (error?.response?.data?.message.includes('sintegra-validation')) {
        return error?.response?.data?.message
      } else if (error?.response?.data?.message)
        errorMsg = error?.response?.data?.message
      toast.error(errorMsg)
    }
  })
}
